import { useEffect, useRef } from 'react';
import { useRecoilValue } from 'recoil';
import { useLocation, useNavigate } from 'react-router-dom';
import { organizationAtom } from './atom';
import { Paths } from 'services/navigation/paths';
import { embeddedCandidatesPath } from 'modules/atsEmbed/constants/atsEmbedLinks';
import { getAtsEmbedContext } from 'modules/atsEmbed/utils/atsEmbedContext';

export const OrganizationChangeListener = () => {
  const organization = useRecoilValue(organizationAtom);
  const prevOrgId = useRef<string | null | undefined>(organization?.id);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Only run on org id change (not on first mount)
    const currentPath = location.pathname;
    const isEmbedded = getAtsEmbedContext() !== null;

    if (
      prevOrgId.current !== undefined &&
      organization?.id !== prevOrgId.current &&
      (isEmbedded || currentPath !== Paths.HOME) &&
      currentPath !== Paths.ATS &&
      !currentPath.includes(Paths.ADMINISTRATOR)
    ) {
      navigate(isEmbedded ? embeddedCandidatesPath : Paths.HOME, {
        replace: true
      });
    }
    prevOrgId.current = organization?.id;
  }, [organization?.id, navigate, location.pathname]);

  return null;
};
